// ─── Events ──────────────────────────────────────────────────────────────────

export type AuthEvent =
  | { type: 'LOGIN'; csrfToken?: string; postLoginRedirectHref?: string }
  | { type: 'LOGOUT'; csrfToken?: string }
  | { type: 'RETRY_SESSION' }
  | { type: 'UPDATE_CSRF_TOKEN'; csrfToken: string }
  | { type: 'CLEAR_POST_LOGIN_REDIRECT_HREF' };
